<template>
    <div class="container second">
        <div class="row">

            <div class="col-8">
                <div class="headline h2">
                    <span>In welchem Umkreis kannst Du Nachhilfe geben?</span>
                </div>


                <div class="row">
                    <div class="col-12">
                        <p class="">Gib an, in welchem Umkreis, ausgehend von Deiner Privatadresse, Du Nachhilfe geben kannst, und welche Verkehrsmittel Du dabei nutzt.</p>
                    </div>
                    <div class="col-6  input-group checkbox-group">
                        <label v-for="(mobPos, mobPosIndex) in mobPosAll" class="checkbox" v-bind:key="mobPosIndex" v-bind:class="{ 'invalid': errors.first('mobility') }">
                            <input type="checkbox" :name="'mobility'" :value="mobPos.name" v-model="mobility"
                                   v-validate="'required|minLength:1'" data-vv-as="Fortbewegungsmöglichkeit" > <span>{{ mobPos.name }}</span>
                        </label>
                        <!--<span class="text-danger" >{{ errors.first('mobility') }}</span>-->
                    </div>
                    <div class="col-5 slider ">
                        <span class="label-left" >2 km</span>
                        <span class="label-right" >20+ km</span>
                        <vue-slider v-model="radius" v-bind="radiusOptions" />
                    </div>

                </div>

            </div>
            <div class="col-4 icon-master">
                <i class="fa fa-map-marker-alt"></i>
            </div>
        </div>
    </div>

</template>

<script>
    import VueSlider from 'vue-slider-component'

    export default {
        name: 'secondStep',
        components: {
            VueSlider
        },

        data: function () {
            return {
                radius: 6,
                mobility: [],

                mobPosAll: [
                    {
                        value: 'oepnv',
                        name: 'Öffentliche Verkehrsmittel'
                    },
                    {
                        value: 'car',
                        name: 'Auto, Roller etc.'
                    },
                    {
                        value: 'bike',
                        name: 'Fahrrad, zu Fuß etc.'
                    }
                ],

                // Slider options
                radiusOptions: {
                    dotSize: 24,
                    height: 10,
                    min: 2,
                    max: 20,
                }
            }
        },

        mounted() {

        },

        methods: {
            nextPage() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        // Success
                        this.$emit('openNextPage', this);
                        return;
                    }
                    if (!result) {
                        // Error
                        console.log(this);
                    }
                });
            }
        }
    }
</script>

<style>
    .slider span {
        font-size: 1rem;

    }
    .slider span.label-right {
        float: right;
    }
    .vue-slider {
        padding-top: 0 !important;
    }
    .vue-slider-rail {
        border: 1px solid gray;
        border-radius: 10px;
        box-sizing: border-box;
    }
    .vue-slider-process {
        background-color: gray;
        border-radius: 5px;
    }
    div.vue-slider-dot {
        background-color: #4d9aa2;
        border-radius: 14px;
        border: 2px solid lightgray;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    div.vue-slider-dot-tooltip {
        top: auto !important;
        visibility: visible !important;
        transform: none !important;
        left: auto !important;
        color: #fff !important;
        font-weight: bold !important;
        font-size: 1.3rem !important;
    }
</style>